import React, { useEffect, useState } from 'react';
import CustomCard, { CustomGridLayout } from '../../../../shared/Cards/CustomCard';
import { CustomCheckbox, CustomDropDown } from '../../../../shared/Input/AllInputs';
import useAgreementPlan from '../../../../hooks/Agreement/useAgreementPlan';
import PrimaryButton, { CustomButtonGroup } from '../../../../shared/Button/CustomButton';
import { useDispatch } from 'react-redux';
import { addDefaultSettings, getdefaultSetting } from '../../../../redux/actions/Settings/Business/defaultSettingActions';

const DefaultSettings = () => {
    const [data, setData] = useState({
        agreementPlan: '',
        fastAddRequiredFields: [],
    });
    const dispatch = useDispatch();

    const handleChange = ({ name, value }) => {
        if (checkboxFields.some((field) => field.name === name)) {
            // It's a checkbox field → update fastAddRequiredFields array
            if (value) {
                setData((prev) => ({
                    ...prev,
                    fastAddRequiredFields: [...prev.fastAddRequiredFields, name],
                }));
            } else {
                setData((prev) => ({
                    ...prev,
                    fastAddRequiredFields: prev.fastAddRequiredFields.filter((n) => n !== name),
                }));
            }
        } else {
            // It's a normal field like agreementPlan
            setData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    console.log('data', data);

    const { agreementPlansDropdown } = useAgreementPlan();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        dispatch(
            getdefaultSetting((data) => {
                setData({
                    agreementPlan: data.agreementPlan,
                    // add this if we have some default setting for fields also
                    fastAddRequiredFields: Array.isArray(data.fastAddRequiredFields) ? data.fastAddRequiredFields : [],
                });
            }),
        );
    }, [dispatch]);

    const handleSave = () => {
        dispatch(addDefaultSettings(data, setLoading));
    };

    const checkboxFields = [
        { label: 'Image', name: 'image' },
        { label: 'Bar Code', name: 'barCode' },
        { label: 'Note', name: 'note' },
        { label: 'First Name', name: 'firstName' },
        { label: 'M I', name: 'MI' },
        { label: 'Last Name', name: 'lastName' },
        { label: 'Gender', name: 'gender' },
        { label: 'Date of Birth', name: 'dob' },
        { label: 'Govt Id', name: 'govtId' },
        { label: 'Primary Number', name: 'primaryPhone' },
        { label: 'Mobile Number', name: 'mobilePhone' },
        { label: 'Work Number', name: 'workNumber' },
        { label: 'Work Ext', name: 'workExt' },
        { label: 'Address', name: 'address' },
        { label: 'Lead Priority', name: 'leadPriority' },
        { label: 'Sales Person', name: 'salesPerson' },
        { label: 'Campaign', name: 'campaign' },
        { label: 'Issued On', name: 'issuedOn' },
        { label: 'Tour On', name: 'tourOn' },
        { label: 'Start On', name: 'startOn' },
        { label: 'Begin On', name: 'beginOn' },
    ];

    return (
        <>
            <CustomCard col="12" title="Default">
                <CustomGridLayout>
                    <CustomDropDown name="agreementPlan" options={agreementPlansDropdown} data={data} onChange={handleChange} required />
                </CustomGridLayout>
            </CustomCard>
            <CustomCard col="12" title="Fast Add Member Specifications">
                <CustomGridLayout>
                    {checkboxFields.map((field) => (
                        <CustomCheckbox
                            key={field.name}
                            label={field.label}
                            name={field.name}
                            data={data}
                            col={2}
                            onChange={handleChange}
                            checked={data.fastAddRequiredFields.includes(field.name)}
                        />
                    ))}
                </CustomGridLayout>
            </CustomCard>

            <CustomButtonGroup>
                <PrimaryButton label="Save" className="mx-2" onClick={handleSave} loading={loading} />
            </CustomButtonGroup>
        </>
    );
};

export default DefaultSettings;
